import { locale } from './index.js';
import { сопоставить } from './подстановка.js';
import uz from './server-uz.js';
import uzCyrl from './server-uz-cyrl.js';

/* Отказы сервера.

   Сервер отдаёт причину отказа готовой строкой по-русски и остаётся одним
   местом правды: новый отказ появляется в API и сразу виден в интерфейсе.
   Перевод накладывается сверху — так же, как на подписи перечислений.

   ПОЧЕМУ КЛЮЧ — ТЕКСТ, А НЕ КОД

   Правильнее было бы отдавать код отказа и собирать фразу на клиенте.
   Но кодов сейчас нет ни у одного из трёхсот с лишним мест, где отказ
   бросается, а менять сервер в трёхстах местах перед пилотом — риск,
   несоразмерный выигрышу. Ключом взят сам русский текст, как в словаре
   кабинета.

   ЧЕМ ЗА ЭТО ПЛАТИМ

   Правка текста на сервере молча разрывает связь с переводом, и отказ
   снова становится русским. Отказ при этом остаётся понятным — человек
   видит причину, просто не на своём языке. Расхождения находит
   tools/i18n/сверить.mjs: её стоит гонять после правок в routes.

   Само сопоставление — в подстановка.js, без импортов, чтобы проверка
   могла прогнать его в node. */

const СЛОВАРИ = { uz, 'uz-Cyrl': uzCyrl };

export function перевестиОтказ(текст) {
  if (!текст) return текст;
  return сопоставить(текст, СЛОВАРИ[locale.value]) ?? текст;
}
